export function gaViewItemObject(products, list = '') {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: {
        detail: {
          products,
          actionField: {
            list,
          },
        },
      },
      event: 'enhancedEcommerceProductDetails',
    });
  }
}

export function gaViewItemCustom(products, list = '', currencyCode = 'EUR') {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'eec.detail',
      ecommerce: {
        currencyCode,
        detail: {
          actionField: {
            list,
          },
          products,
        },
      },
    });
  }
}

export function gaViewProductGeneralObject(product) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      productDetails: product,
    });
  }
}

export function gaViewItemImpresssionObject(products, currency = 'EUR') {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: {
        currencyCode: currency,
        impressions: products,
      },
      event: 'enhancedEcommerceProductImpressions',
    });
  }
}

export function gaAddToCartObject(product) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'addToCart',
      addToCart: product,
    });
  }
}

export function gaRemoveFromCartObject(product) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'removeFromCart',
      removeFromCart: product,
    });
  }
}

export function gaAddToCartCustom(products, list = '', currencyCode = 'EUR') {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'eec.add',
      ecommerce: {
        currencyCode,
        add: {
          actionField: {
            list,
          },
          products,
        },
      },
    });
  }
}

export function gaCheckoutStepObject(step) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'checkoutStep',
      checkoutStep: {
        step,
      },
    });
  }
}

export function gaCheckoutStepCustom(
  products,
  step = 1,
  currencyCode = 'EUR',
  option = '',
) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'eec.checkout',
      ecommerce: {
        currencyCode,
        checkout: {
          actionField: {
            step,
            option,
          },
          products,
        },
      },
    });
  }
}

export function gaPurchaseObject(products, actionField = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: {
        purchase: {
          actionField,
          products,
        },
      },
      event: 'enhancedEcommercePurchase',
    });

    window.dataLayer.push({
      event: 'checkoutStep',
      checkoutStep: {
        step: 4,
      },
    });
  }
}

export function gaPurchaseCustom(
  products,
  actionField = {},
  customer = {},
  currencyCode = 'EUR',
) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'eec.purchase',
      ecommerce: {
        currencyCode,
        purchase: {
          actionField,
          products,
          customer,
        },
      },
    });
  }
}

export function gaTrackPromotionClick(promotion) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'promoClick',
      promotionClicked: promotion,
    });
  }
}

export function gaTrackProductClick(product) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'productClick',
      productClicked: product,
    });
  }
}

export function gaTrackPromotionImpressions(promotions, list) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: {
        promoView: {
          actionField: { list },
          promotions,
        },
      },
      event: 'enhancedEcommercePromotionImpressions',
    });
  }
}

export function gaAdsRemarketingHomeView() {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'googleDynamicRemarketing',
      googleDynamicRemarketing: {
        ecomm_pagetype: 'home',
      },
    });
  }
}

export function gaAdsRemarketingSearchView(value, ids) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'googleDynamicRemarketing',
      googleDynamicRemarketing: {
        ecomm_pagetype: 'searchresults',
        ecomm_totalvalue: value,
        ecomm_prodid: ids,
      },
    });
  }
}

export function gaAdsRemarketingCategoryView(value, ids, categoryNames) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'googleDynamicRemarketing',
      googleDynamicRemarketing: {
        ecomm_pagetype: 'category',
        ecomm_totalvalue: value,
        ecomm_prodid: ids,
        ecomm_pcat: categoryNames,
      },
    });
  }
}

export function gaAdsRemarketingProductView(
  value,
  id,
  productName,
  categoryNames,
) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'googleDynamicRemarketing',
      googleDynamicRemarketing: {
        ecomm_pagetype: 'product',
        ecomm_totalvalue: value,
        ecomm_prodid: id,
        dynx_itemid: id,
        ecomm_pname: productName,
        ecomm_pcat: categoryNames,
      },
    });
  }
}

export function gaAdsRemarketingCartView(
  value,
  ids,
  productPrices,
  productNames,
  categoryNames,
) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'googleDynamicRemarketing',
      googleDynamicRemarketing: {
        ecomm_pagetype: 'cart',
        ecomm_totalvalue: value,
        ecomm_prodid: ids,
        ecomm_pvalue: productPrices,
        ecomm_pname: productNames,
        ecomm_pcat: categoryNames,
      },
    });
  }
}

export function gaAdsRemarketingPurchaseView(value, ids) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'googleDynamicRemarketing',
      googleDynamicRemarketing: {
        ecomm_pagetype: 'purchase',
        ecomm_totalvalue: value,
        ecomm_prodid: ids,
      },
    });
  }
}

export function gaAdsRemarketingOtherView() {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'googleDynamicRemarketing',
      googleDynamicRemarketing: {
        ecomm_pagetype: 'other',
      },
    });
  }
}

function gaTrackFbPixelObject(trackName, trackInfo = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'trackFBPixel',
      fb_pixel_track_name: trackName,
      fb_pixel_track_info: trackInfo,
    });
  }
}

export function gaTrackFbHomepageView() {
  gaTrackFbPixelObject('PageView', {});
}

export function gaTrackFbSearchView(value, currency, searchString) {
  gaTrackFbPixelObject('Search', {
    value,
    currency,
    search_string: searchString,
  });
}

export function gaTrackFbProductView(value, currency, productId, productName) {
  gaTrackFbPixelObject('ViewContent', {
    value,
    currency,
    content_ids: [productId],
    content_name: productName,
    content_type: 'product',
  });
}

export function gaTrackFbCartView(
  value,
  currency,
  productsCount,
  contentType,
  productIds,
) {
  gaTrackFbPixelObject('InitiateCheckout', {
    value,
    currency,
    num_items: productsCount,
    content_type: contentType,
    content_ids: productIds,
  });
}

export function gaTrackFbPurchase(
  value,
  currency,
  productsCount,
  contentType,
  productIds,
) {
  gaTrackFbPixelObject('Purchase', {
    value,
    currency,
    num_items: productsCount,
    content_type: contentType,
    content_ids: productIds,
  });
}

export function gaTrackFbRegister(currency) {
  gaTrackFbPixelObject('CompleteRegistration', {
    value: '0.00',
    currency,
  });
}
